// extracted by mini-css-extract-plugin
module.exports = {"support-phone__text":"support-phone__text--2ctAU","support-phone__icon":"support-phone__icon--2g69m"};